import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFortyNinePreLogin',
    name: 'IFPageOneHFortyNinePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortyNineLogin' ||
        from.path === '/IFPageOneHFortyNineLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortyNineLogin',
    name: 'pageOneHFortyNineLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/login.vue'),
  },
  /*{
    path: '/IFPageOneHFortyNineLoginLoading',
    name: 'pageOneHFortyNineLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortyNineLeaveInfo',
    name: 'pageOneHFortyNineLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortyNineResult',
    name: 'pageOneHFortyNineResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/result.vue'),
  },
  {
    path: '/IFPageOneHFortyNineLoading',
    name: 'pageOneHFortyNineLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },*/
  {
    path: '/IFPageOneHFortyNineLoginSecond',
    name: 'pageOneHFortyNineLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  /*{
    path: '/IFPageOneHFortyNineOnline',
    name: 'pageOneHFortyNineOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /!* 网贷来源页 *!/
      if (from.path == '/IFPageOneHFortyNineLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },*/
  {
    path: '/IFPageOneHFortyNineGuide',
    name: 'pageOneHFortyNineLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFiftyNine/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHFortyNineCar',
    name: 'pageOneHFortyNineCar',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortyNineCarDetails',
    name: 'pageOneHFortyNineCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },
  {
    path: '/IFPageOneHFortyNineBlank',
    name: 'pageOneHFortyNineBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyNineOnlineTab',
    name: 'pageOneHFortyNineOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyNineOnlineAd',
    name: 'pageOneHFortyNineOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortyNine/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },*/
];
